<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="`${size}px`" :height="`${size}px`" viewBox="0 0 40 40" fill="none">
        <path
            ref="fillPathRef"
            :class="fillClass"
            d="m20 40-5-4H1.971a1 1 0 0 1-1-.972L.03 1.029A1 1 0 0 1 1.03 0h37.94a1 1 0 0 1 1 1.03l-.944 33.998a1 1 0 0 1-1 .972H25l-5 4z"
        />

        <path
            ref="outlinePathRef"
            :class="outlineClass"
            d="M38.97 1.002 38.026 35H25a1 1 0 0 0-.625.22L20 38.72l-4.376-3.5A1 1 0 0 0 15 35H1.973L1.03 1m0-1a1 1 0 0 0-1 1.03l.943 33.998a1 1 0 0 0 1 .972h13.027l5 4 5-4h13.028a1 1 0 0 0 1-.972l.942-33.999a1 1 0 0 0-1-1.029H1.03z"
        />

        <!-- Overlay -->
        <path v-if="overlayPathData" :d="overlayPathData" fill="#FFF" />
    </svg>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { collectionPinProps, useCollectionPinComponent, usePinOverlayComponent } from '../../composables/useCollection';
import { CollectionType } from 'ihunter-common';

const props = defineProps({
    ...collectionPinProps(CollectionType.Waypoint),
});

const { size, fillClass, outlineClass, initializeStyleFillColor, initializeStyleOutlineColor } = useCollectionPinComponent(props);
const { overlayPathData, initializeOverlayPathData } = usePinOverlayComponent(props);

const fillPathRef = ref(null);
const outlinePathRef = ref(null);

onMounted(() => {
    initializeStyleFillColor(fillPathRef);
    initializeStyleOutlineColor(outlinePathRef);
    initializeOverlayPathData();
});
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

@include Pathfinder.Pin;
</style>
